export const pageNavigationMixin = {
  props: {
    fallback: {
      type: [String, Object],
      default: null
    }
  },

  methods: {
    $_pageNavigationMixin_gotoPreviousPage() {
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;

        this.$router.push({ path: previousPath });
      } else {
        if (this.fallback) {
          this.$router.push(this.fallback);
        } else {
          this.$router.go(-1);
        }
      }
    }
  }
};
